export const VendorDetailActiveOffersPageSize = 9;
export const VendorDetailActiveOffersPageSize = 9;
